module.exports = __webpack_public_path__ + "newWebTMS/img/reset-password.227b2382.png";